import {FormatterProps} from './Common';
import React from 'react';


export const CustomOneSearch: React.FC<FormatterProps> = (props) => {
    const formatter = layoutSearchFormatters[props.field.type];

    return formatter ? formatter(props) : unknownFieldType(props);
};

export const CustomOneFilter: React.FC<FormatterProps> = (props) => {
    const formatter = layoutFilterFormatters[props.field.type];

    return formatter ? formatter(props) : unknownFieldType(props);
};

const SingleSearchSelect: React.FC<FormatterProps> = (props) => {
    return (
        <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12 form-group">
            <label className="font-weight-bold" htmlFor={props.field.name}>
                {props.field.label}
            </label>
            <div className="d-flex d-flex-row">
                <div className="mr-1">
                    {props.field.options.map((option, idx) => (
                        <div className="form-check" key={option}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`${props.field.name}_${idx}`}
                                value={option}
                                onChange={($this) =>
                                    props.onChange(props.id, $this.currentTarget.value)
                                }
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`${props.field.name}_${idx}`}
                            >
                                {option}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>);
};

const iconMap: {[label: string]: string} = {
    'Art Program': 'fa-palette',
    'Before/After-School Program & Tutoring': 'fa-book-open',
    'College & Career Readiness': 'fa-graduation-cap',
    'Nutrition': 'fa-utensils',
    'Parents/Caregivers': 'fa-hand-holding-heart',
    'Physical & Mental Healthcare': 'fa-medkit',
    'Upcoming Events': 'fa-calendar',
    'Whole-Family Support': 'fa-people-roof',
    'Other': 'fa-hands-holding-circle',
};

const MultiSearchSelect: React.FC<FormatterProps> = (props) => {
    switch (props.field.name) {
        case 'program_focus_area':
            // Custom render for 'status' field
            return (
                <>
                    <div className="row my-3">
                        <h5 className="col">Program Focus Area</h5>
                    </div>
                    <div className="row">
                        {props.field.options.map((o, idx) => (
                            <div key={o} className="col-lg-4 col-md-6 col-xs-12">
                                <button
                                    className={`btn primary-focus-btn mb-2 w-100 button-${idx + 1}`}
                                    style={{borderRadius: 5}}
                                    data-toggle="button"
                                    onClick={() => props.onChange(props.id, o)}
                                >
                                    <div className="d-flex align-items-center p-2 font-weight-bold">
                                        {/* You can add icons or other dynamic content here */}
                                        <div className="mr-2">
                                            {iconMap[o] ? (
                                                <em className={`fa-solid ${iconMap[o]}`} />
                                            ) : null}
                                        </div>
                                        <div className="text-center" style={{width: '100%'}}>
                                            {o}
                                        </div>
                                    </div>
                                </button>
                            </div>
                        ))}
                    </div>
                </>

            );
        case 'resource_type':
            // Custom render for 'category' field
            return (
                <div className="col-xl-3 col-lg-4 col-md-6 col-xs-12 form-group">
                    <label className="font-weight-bold" htmlFor={props.field.name}>
                        {props.field.label}
                    </label>
                    <div className="d-flex d-flex-row">
                        <div className="mr-1">
                            {props.field.options.map((option, idx) => (
                                <div className="form-check" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`${props.field.name}_${idx}`}
                                        value={option}
                                        onChange={($this) => props.onChange(props.id, $this.currentTarget.value)}
                                        // You can add checked/onChange for controlled checkboxes as needed
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`${props.field.name}_${idx}`}
                                    >
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        default:
            // Fallback to a default renderer
            return (
                <div />
            );
    }
};

const LongSearchText: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Reformat me: {props.field.type}:</strong>
    </div>
);

const ShortSearchText: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Reformat me: {props.field.type}:</strong>
    </div>
);

const SingleFilterSelect: React.FC<FormatterProps> = (props) => {
    return (
        <div className="col-12 form-group">
            <label className="font-weight-bold" htmlFor={props.field.name}>
                {props.field.label}
            </label>
            <div className="d-flex d-flex-row">
                <div className="mr-1">
                    {props.field.options.map((option, idx) => {
                        // checked should be a boolean variable, true if checked, false otherwise
                        const checked =
                            Array.isArray(props.query?.[props.id]) &&
                            props.query![props.id]!.includes(option);
                        return (
                            <div className="form-check" key={option}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`${props.field.name}_${idx}`}
                                    value={option}
                                    checked={checked}
                                    onChange={($this) =>
                                        props.onChange(props.id, $this.currentTarget.value, false)
                                    }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`${props.field.name}_${idx}`}
                                >
                                    {option}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const MultiFilterSelect: React.FC<FormatterProps> = (props) => {
    switch (props.field.name) {
        case 'program_focus_area':
            // Custom render for 'status' field
            return (
                <>
                    <div className="row my-3">
                        <h5 className="col">Program Focus Area</h5>
                    </div>
                    <div className="row">
                        {props.field.options.map((o, idx) => {
                            // Get toggled value. You can adjust this as needed:
                            const toggled =
                                Array.isArray(props.query?.[props.id]) &&
                                props.query![props.id]!.includes(o);

                            return (
                                <div key={o} className="col-12">
                                    <button
                                        className={`btn primary-focus-btn mb-2 w-100 button-${idx + 1} ${toggled ? "active" : ""}`}
                                        style={{
                                            borderRadius: 5,
                                            background: toggled ? "#cce4fc" : undefined
                                        }}
                                        data-toggle="button"
                                        onClick={() => props.onChange(props.id, o)}
                                    >
                                        <div className="d-flex align-items-center p-2 font-weight-bold">
                                            {/* You can add icons or other dynamic content here */}
                                            <div className="mr-2">
                                                {iconMap[o] ? (
                                                    <em className={`fa-solid ${iconMap[o]}`} />
                                                ) : null}
                                            </div>
                                            <div className="text-center" style={{ width: '100%' }}>
                                                {o}
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </>
            );

        case 'resource_type':
            // Custom render for 'category' field
            return (
                <div className="col-12 form-group">
                    <label className="font-weight-bold" htmlFor={props.field.name}>
                        {props.field.label}
                    </label>
                    <div className="d-flex d-flex-row">
                        <div className="mr-1">
                            {props.field.options.map((option, idx) => {
                                const checked =
                                    Array.isArray(props.query?.[props.id]) &&
                                    props.query![props.id]!.includes(option);

                                return (
                                    <div className="form-check" key={option}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`${props.field.name}_${idx}`}
                                            value={option}
                                            checked={checked}
                                            onChange={($this) => props.onChange(props.id, $this.currentTarget.value)}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={`${props.field.name}_${idx}`}
                                        >
                                            {option}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        default:
            // Fallback to a default renderer
            return (
                <div />
            );
    }
};

const LongFilterText: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Reformat filter me: {props.field.type}:</strong>
    </div>
);

const ShortFilterText: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Reformat filter me: {props.field.type}:</strong>
    </div>
);

const UnknownFieldType: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Strange new unsupported type detected {props.field.type}</strong>
    </div>
);

const singleSearchSelect = (props: FormatterProps) => <SingleSearchSelect {...props} />;
const multiSearchSelect = (props: FormatterProps) => <MultiSearchSelect {...props} />;
const shortSearchText = (props: FormatterProps) => <ShortSearchText {...props} />;
const longSearchText = (props: FormatterProps) => <LongSearchText {...props} />;
const unknownFieldType = (props: FormatterProps) => <UnknownFieldType {...props} />;

const singleFilterSelect = (props: FormatterProps) => <SingleFilterSelect {...props} />;
const multiFilterSelect = (props: FormatterProps) => <MultiFilterSelect {...props} />;
const shortFilterText = (props: FormatterProps) => <ShortFilterText {...props} />;
const longFilterText = (props: FormatterProps) => <LongFilterText {...props} />;


// Mapping of layout name to formatter
const layoutSearchFormatters: {[key: string]: (props: FormatterProps) => JSX.Element} = {
    'Single Select': singleSearchSelect,
    'Multi Select': multiSearchSelect,
    'Short Text': shortSearchText,
    'Long Text': longSearchText,
};

const layoutFilterFormatters: {[key: string]: (props: FormatterProps) => JSX.Element} = {
    'Single Select': singleFilterSelect,
    'Multi Select': multiFilterSelect,
    'Short Text': shortFilterText,
    'Long Text': longFilterText,
};


// WEBPACK FOOTER //
// ./src/public/search/layout/CustomOne.tsx